import { atom } from 'jotai';
import type { ImageSettingsT } from '../../labelling/providers/stage-provider';
export const DEFAULT_IMAGE_SETTINGS: ImageSettingsT = {
  // Image brightness is percentage - reference https://developer.mozilla.org/en-US/docs/Web/CSS/filter-function/brightness
  brightness: 100,
  // Image contrast in percentage - reference https://developer.mozilla.org/en-US/docs/Web/CSS/filter-function/contrast
  contrast: 100
};
export const imageSettingsAtom = atom<ImageSettingsT>(DEFAULT_IMAGE_SETTINGS);